import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'primereact/button';
import { useCart } from '../context/CartContext';
import { useFavorites } from '../context/FavoritesContext';
import { getProductImageUrl } from '../utils/imageUtils';

const ProductCard = ({ product }) => {
    const navigate = useNavigate();
    const { addToCart } = useCart();
    const { toggleFavorite, isFavorite } = useFavorites();

    // Mapear ID del producto: el backend retorna idProducto
    const productId = product.id || product.idProducto;
    const fav = isFavorite(productId);

    const handleAddToCart = (e) => {
        e.stopPropagation();
        addToCart(product);
    };

    const handleToggleFavorite = (e) => {
        e.stopPropagation();
        toggleFavorite(product);
    };

    const renderStars = (rating) => {
        const stars = [];
        const fullStars = Math.floor(rating);
        for (let i = 0; i < 5; i++) {
            stars.push(
                <i
                    key={i}
                    className={i < fullStars ? 'pi pi-star-fill' : 'pi pi-star'}
                ></i>
            );
        }
        return stars;
    };

    const savingsAmount = product.oldPrice ? (product.oldPrice - (product.price || product.precioVenta)).toFixed(2) : null;

    // Mapear propiedades del backend al componente
    const displayName = product.name || product.nombre || 'Producto sin nombre';
    const displayPrice = product.price || product.precioVenta || 0;
    const displayImage = getProductImageUrl(product);
    const displayBrand = product.brand || product.marca || 'Sin marca';
    const displayRating = product.rating || 0;
    const displayReviewCount = product.reviewCount || product.reviewCount || 0;

    return (
        <div
            className="ec-product-card"
            onClick={() => navigate(`/tienda/producto/${productId}`)}
        >
            {/* Image Section */}
            <div className="ec-product-card-image">
                <div className="ec-product-badge">
                    {product.discount > 0 && (
                        <span className="ec-badge-discount">-{product.discount}%</span>
                    )}
                    {product.isNew && (
                        <span className="ec-badge-new">NUEVO</span>
                    )}
                </div>

                <Button
                    icon={fav ? 'pi pi-heart-fill' : 'pi pi-heart'}
                    className={`ec-product-fav p-button-text p-button-rounded ${fav ? 'is-fav' : ''}`}
                    onClick={handleToggleFavorite}
                />

                <img
                    src={displayImage}
                    alt={displayName}
                    loading="lazy"
                />
            </div>

            {/* Body */}
            <div className="ec-product-card-body">
                <span className="ec-product-brand">{displayBrand}</span>
                <h3 className="ec-product-name">{displayName}</h3>

                <div className="ec-product-rating">
                    {renderStars(displayRating)}
                    <span>({displayReviewCount})</span>
                </div>

                <div className="ec-product-pricing">
                    <span className="ec-product-price">${displayPrice.toFixed(2)}</span>
                    {product.oldPrice && (
                        <span className="ec-product-oldprice">${product.oldPrice.toFixed(2)}</span>
                    )}
                </div>

                {savingsAmount && (
                    <span className="ec-product-save" style={{ marginBottom: 14 }}>
                        Ahorra ${savingsAmount}
                    </span>
                )}

                <Button
                    label="Agregar al carrito"
                    icon="pi pi-shopping-cart"
                    className="ec-product-addcart"
                    onClick={handleAddToCart}
                />
            </div>
        </div>
    );
};

export default ProductCard;
